const AUTOMATIC_BOARD_MAX_SIZE = 704;
const MANUAL_BOARD_MAX_SIZE = 960;
const BOARD_PANEL_WIDTH = 400;
const BOARD_PANEL_GAP = 16;
const DESKTOP_PAGE_PADDING = 32;
const BOARD_OVERHEAD = 44;
const MIN_BOARD_SIZE = 420;

export function getSize(manualBoardSize: number | null = null) {
  const screenHeight = window.innerHeight;
  let screenWidth = window.innerWidth;

  // Use document.documentElement.clientWidth as fallback - it excludes scrollbar
  // and is more reliable on some mobile browsers
  const clientWidth = document.documentElement?.clientWidth || screenWidth;
  screenWidth = Math.min(screenWidth, clientWidth);

  let boardSize;
  const isDesktop = screenWidth > 768;
  if (isDesktop) {
    const adSize = 160; //showAd ? (screenWidth < 1025 ? 160 : 160) : 0;
    const maxBoardSize = Math.min(
      Math.round(screenHeight - 150),
      screenWidth - 400 - adSize
    );
    const maxManualBoardSize = Math.max(
      MIN_BOARD_SIZE,
      Math.min(
        MANUAL_BOARD_MAX_SIZE,
        screenHeight - 150 - BOARD_OVERHEAD,
        screenWidth - BOARD_PANEL_WIDTH - BOARD_PANEL_GAP - DESKTOP_PAGE_PADDING
      )
    );

    if (manualBoardSize) {
      boardSize = Math.min(
        Math.max(manualBoardSize, MIN_BOARD_SIZE),
        maxManualBoardSize
      );
      boardSize -= boardSize % 8;
    } else if (maxBoardSize > AUTOMATIC_BOARD_MAX_SIZE) {
      boardSize = AUTOMATIC_BOARD_MAX_SIZE;
    } else if (maxBoardSize < MIN_BOARD_SIZE) {
      boardSize = MIN_BOARD_SIZE;
    } else {
      boardSize = maxBoardSize - (maxBoardSize % 8);
    }
  } else {
    // On mobile, ensure board fits within viewport
    // Use the smaller of innerWidth and clientWidth, minus a small buffer for safety
    screenWidth = Math.min(screenWidth, clientWidth);
    screenWidth -= screenWidth % 2;
    boardSize = screenWidth;
  }
  return { boardSize, isDesktop, height: screenHeight };
}
